(() => {
  const readJson = (root, selector, fallback = {}) => {
    try { return JSON.parse(root.querySelector(selector)?.textContent || 'null') || fallback; } catch { return fallback; }
  };
  const initialize = root => {
    if (root.dataset.fmPdpReady) return;
    root.dataset.fmPdpReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const form = root.querySelector('#add-to-cart-form');
    const product = readJson(root, '[data-fm-pdp-product]');
    const inventory = readJson(root, '[data-fm-pdp-inventory]');
    const purchaseText = readJson(root, '[data-fm-pdp-purchase-text]');
    const copy = readJson(root, '[data-fm-pdp-text]');
    const clarity = readJson(root, '[data-fm-clarity-text]');
    const uploadRoot = form?.querySelector('[data-upload-lift]');
    const tidyUploadLabels = () => {
      if (!copy.uploadPhoto || root.dataset.fmIsAdvent === 'true') return;
      uploadRoot?.querySelectorAll('.filepond--drop-label label').forEach(label => {
        const original = label.textContent.trim().replace(/\s+/g, ' ');
        if (/^UPLOAD YOUR IMAGE HERE \(ONE IMAGE\/PACK OPTION\)$/i.test(original)) {
          const packNote = root.querySelector('[data-fm-upload-pack-note]');
          if (packNote) packNote.hidden = false;
          const nodes = [...label.childNodes].filter(node => node.nodeType === 3 && node.textContent.trim());
          if (nodes.length === 1) nodes[0].textContent = copy.uploadPhoto;
        } else if (/^Add your photo or Browse$/i.test(original)) {
          [...label.childNodes].filter(node => node.nodeType === 3 && node.textContent.trim()).forEach(node => { node.textContent = copy.uploadPhoto + ' · '; });
        } else if (/^Drag\s*&\s*Drop your files or Browse$/i.test(original)) {
          [...label.childNodes].filter(node => node.nodeType === 3 && /Drag\s*&\s*Drop/i.test(node.textContent)).forEach(node => { node.textContent = copy.uploadOr + ' '; });
        }
      });
    };
    tidyUploadLabels();
    if (uploadRoot && typeof MutationObserver !== 'undefined') {
      const uploadObserver = new MutationObserver(tidyUploadLabels);
      uploadObserver.observe(uploadRoot, {childList: true, subtree: true, characterData: true});
      signal.addEventListener('abort', () => uploadObserver.disconnect(), {once: true});
    }
    const nativeSelect = form?.querySelector('[name="id"]');
    const quantity = form?.querySelector('[name="quantity"]');
    const atc = form?.querySelector('#product-add-to-cart');
    const options = [...(form?.querySelectorAll('.swatch[data-option-index]') || [])];
    const gallery = root.querySelector('[data-fm-pdp-gallery]');
    const dialog = gallery?.querySelector('[data-fm-zoom-dialog]');
    const money = value => new Intl.NumberFormat(purchaseText.locale || 'en', {style:'currency', currency:purchaseText.currency || 'USD'}).format(value / 100);
    let current = (product.variants || []).find(variant => String(variant.id) === String(nativeSelect?.value));
    let returnFocus;
    const selectMedia = id => {
      if (!gallery) return;
      const slides = [...gallery.querySelectorAll('[data-fm-media-id]')];
      const selected = slides.find(slide => slide.dataset.fmMediaId === String(id) || slide.dataset.fmImageId === String(id));
      if (!selected) return;
      slides.forEach(slide => {
        slide.hidden = slide !== selected;
        slide.classList.toggle('slick-current', slide === selected);
        if (slide.hidden) slide.querySelector('video')?.pause();
      });
      gallery.querySelectorAll('[data-fm-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fmMediaTarget === selected.dataset.fmMediaId)));
    };
    const updateQuantity = () => {
      const count = Math.max(1, Math.floor(Number(quantity?.value) || 1));
      if (quantity) quantity.value = String(count);
      const subtotal = root.querySelector('.total-money');
      if (subtotal && current) subtotal.textContent = money(current.price * count);
      const summary = root.querySelector('[data-fm-pack-clarity]');
      if (summary) {
        const group = options.find(group => group.classList.contains('fm-pdp-options--packages'));
        const match = current?.options[Number(group?.dataset.optionIndex)]?.match(/^PACK\s+(\d+)\b/i);
        const packSize = match ? Number(match[1]) : 0;
        summary.hidden = !packSize;
        if (packSize) {
          const items = packSize * count;
          summary.querySelector('[data-fm-pack-total]').textContent = clarity.packTotal.replace('[packs]',count).replace('[items]',items);
          summary.querySelector('[data-fm-unit-price]').textContent = clarity.unitPrice.replace('[price]',money(current.price / packSize));
          summary.querySelector('[data-fm-shipping-total]').textContent = items <= 100 ? clarity.shippingTotal.replace('[price]',money(595 + 250 * (items - 1))) : clarity.shippingLimit;
        }
      }
    };
    const update = variant => {
      current = variant;
      if (atc) {
        const available = Boolean(variant?.available);
        atc.disabled = !available;
        atc.classList.toggle('disabled', !available);
        atc.value = !available ? purchaseText.soldout : variant.inventory_management && Number(inventory[variant.id]) <= 0 ? purchaseText.preorder : purchaseText.add;
      }
      if (!variant) {
        if (nativeSelect) nativeSelect.value = '';
        const selection = root.querySelector('[data-fm-pdp-selection]');
        if (selection) selection.textContent = copy.unavailable;
        return;
      }
      if (nativeSelect) nativeSelect.value = String(variant.id);
      const price = root.querySelector('.prices .price');
      const compare = root.querySelector('.prices .compare-price');
      const saving = root.querySelector('.prices .you-save');
      const isSale = variant.compare_at_price > variant.price;
      if (price) { price.textContent = money(variant.price); price.classList.toggle('on-sale', isSale); }
      if (compare) { compare.style.display = isSale ? '' : 'none'; compare.textContent = isSale ? money(variant.compare_at_price) : ''; }
      if (saving) {
        saving.style.display = isSale ? '' : 'none';
        saving.querySelector('.percent').textContent = isSale ? `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
        saving.querySelector('.diff').textContent = isSale ? money(variant.compare_at_price - variant.price) : '';
      }
      const priceField = root.querySelector('#product_regular_price');
      if (priceField) priceField.value = String(variant.price);
      options.forEach(group => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('input[type="radio"]').forEach(radio => { radio.checked = variant.options[index] === radio.value; });
        const checked = group.querySelector('input:checked');
        const label = checked?.nextElementSibling;
        const selectedLabel = group.querySelector('[data-option-select]');
        if (selectedLabel) selectedLabel.textContent = label?.dataset.fmDisplayOption || variant.options[index];
      });
      const labels = options.map(group => {
        const label = group.querySelector('input:checked')?.nextElementSibling;
        return (label?.querySelector('.fm-pdp-option__text') || label)?.textContent.trim();
      }).filter(Boolean);
      const selection = root.querySelector('[data-fm-pdp-selection]');
      if (selection) selection.textContent = labels.length ? labels.join(' · ') : variant.title === 'Default Title' ? '' : variant.title;
      const delivery = root.querySelector('[data-fm-delivery-text]');
      if (delivery) delivery.textContent = variant.options.some(value => /^fast shipping/i.test(value)) ? copy.fast : copy.standard;
      const packageNote = root.querySelector('[data-fm-pdp-package-note]');
      if (packageNote && root.dataset.fmIsAdvent === 'true') {
        const count = variant.options.find(value => /custom/i.test(value))?.match(/\d+/)?.[0];
        if (count) packageNote.textContent = variant.options.some(value => /^all 24/i.test(value)) ? copy.adventAll : copy.advent.replace('[count]', count);
      }
      updateQuantity();
      if (variant.featured_media?.id || variant.featured_image?.id) selectMedia(variant.featured_media?.id || variant.featured_image?.id);
    };
    form?.addEventListener('change', event => {
      if (event.target.matches('.swatch input[type="radio"]')) {
        const selected = options.map(group => group.querySelector('input:checked')?.value);
        const variant = (product.variants || []).find(candidate => candidate.options.every((value, index) => value === selected[index]));
        update(variant);
        if (variant) {
          nativeSelect?.dispatchEvent(new Event('change', {bubbles:true}));
          const url = new URL(location.href);
          url.searchParams.set('variant', String(variant.id));
          history.replaceState({}, '', url);
          document.dispatchEvent(new CustomEvent('famiily:variant-change', {detail:{variant}}));
        }
      } else if (event.target === nativeSelect) {
        update((product.variants || []).find(variant => String(variant.id) === String(nativeSelect.value)));
      } else if (event.target === quantity) updateQuantity();
    }, {signal});
    form?.addEventListener('click', event => {
      const step = event.target.closest('[data-minus-qtt], [data-plus-qtt]');
      if (step && quantity) {
        event.preventDefault();
        const count = Math.max(1, Math.floor(Number(quantity.value) || 1) + (step.hasAttribute('data-plus-qtt') ? 1 : -1));
        quantity.value = String(count);
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }, {signal});
    const validate = event => {
      if (!form || event.type === 'click' && !event.target.closest('#product-add-to-cart, .shopify-payment-button')) return;
      if (!current?.available || !form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
      }
    };
    form?.addEventListener('click', validate, {capture:true, signal});
    form?.addEventListener('submit', validate, {capture:true, signal});
    gallery?.addEventListener('click', event => {
      const thumbnail = event.target.closest('[data-fm-media-target]');
      if (thumbnail) selectMedia(thumbnail.dataset.fmMediaTarget);
      const zoom = event.target.closest('[data-fm-zoom]');
      if (zoom && dialog?.showModal) {
        event.preventDefault();
        const image = dialog.querySelector('[data-fm-zoom-image]');
        image.src = zoom.href;
        image.alt = zoom.querySelector('img')?.alt || '';
        returnFocus = zoom;
        dialog.showModal();
      }
      if (event.target.closest('[data-fm-zoom-close]')) dialog?.close();
    }, {signal});
    dialog?.addEventListener('close', () => returnFocus?.focus(), {signal});
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) controller.abort(); }, {signal});
    update(current);
  };
  const boot = (scope = document) => {
    if (scope.matches?.('[data-fm-pdp]')) initialize(scope);
    scope.querySelectorAll('[data-fm-pdp]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true}); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

